import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock, ArrowLeft } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/dashboard", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/dashboard");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full bg-white/5 border border-white/10 text-white placeholder-white/30 px-4 py-3.5 rounded-none focus:outline-none focus:ring-1 focus:ring-gold focus:border-gold transition-colors";

  return (
    <div className="min-h-screen bg-[#050507] flex items-center justify-center px-6 font-sans">
      <div className="noise" />
      <div className="w-full max-w-md">
        <Link to="/" data-testid="login-back" className="inline-flex items-center gap-2 text-white/40 hover:text-gold overline mb-10 transition-colors">
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="border border-white/10 bg-[#0F0F13] p-10">
          <div className="w-12 h-12 border border-gold/40 flex items-center justify-center text-gold mb-8">
            <Lock size={20} />
          </div>
          <div className="overline text-gold mb-2">Admin Access</div>
          <h1 className="font-serif text-4xl tracking-tight mb-8">Leads Dashboard</h1>
          <form onSubmit={submit} data-testid="login-form" className="space-y-5">
            <div>
              <label className="overline text-white/50 block mb-2">Email</label>
              <input data-testid="login-email" type="email" className={inputClass} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            </div>
            <div>
              <label className="overline text-white/50 block mb-2">Password</label>
              <input data-testid="login-password" type="password" className={inputClass} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <div data-testid="login-error" className="text-red-400 text-sm">{error}</div>}
            <button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-gold text-black overline px-8 py-4 hover:bg-[#F3E5AB] transition-colors disabled:opacity-60">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
